import {
  GrupoPermissaoAttributes,
  UpdateGrupoPermissao,
} from "@fl/shared/src/types/models/suporte_fl/permissoes";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { groupPermissionsSchema } from "../../../schemas/permissions";

interface IProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  data: UpdateGrupoPermissao | undefined;
  setData: React.Dispatch<
    React.SetStateAction<UpdateGrupoPermissao | undefined>
  >;
  onUpdate: (group: UpdateGrupoPermissao) => void;
}

export type GroupPermissionsFormInputs = Omit<
  GrupoPermissaoAttributes,
  "id_grupo_permissao" | "createdAt" | "updatedAt"
>;

const ModalGroupPermissions: React.FC<IProps> = ({
  showModal,
  setShowModal,
  data,
  setData,
  onUpdate,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm<GroupPermissionsFormInputs>({
    resolver: yupResolver(groupPermissionsSchema),
  });

  useEffect(() => {
    if (data) {
      clearErrors();
      setValue("nome", data.nome);
      setValue("descricao", data.descricao);
    }
  }, [data]);

  const onSubmit: SubmitHandler<GroupPermissionsFormInputs> = async (
    newData
  ) => {
    if (data) {
      var updated_data: UpdateGrupoPermissao = { ...data, ...newData };
      onUpdate(updated_data);
    }
  };

  const handleReset = () => {
    reset({ ...data });
  };

  const [forceUpdateTrigger, setForceUpdateTrigger] = useState(false);
  const forceUpdate = () => {
    setForceUpdateTrigger((prev) => !prev);
  };

  return (
    <Modal
      show={showModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        setData(undefined);
        setShowModal(false);
      }}
    >
      {data && (
        <>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {data.new
                ? "Novo Grupo de Permissões"
                : `Alterar Grupo de Permissões [${data.nome}]`}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Row className="mt-2">
                <Col className="mt-1">
                  <Form.Group controlId="formNome">
                    <Form.Label>Nome do Grupo de Permissões:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite o nome do grupo"
                      {...register("nome")}
                      isInvalid={!!errors.nome}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.nome?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col className="mt-1">
                  <Form.Group controlId="formDescricao">
                    <Form.Label>Descrição:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite a descrição do grupo"
                      {...register("descricao")}
                      isInvalid={!!errors.descricao}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.descricao?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-between"
            >
              <Button
                variant="outline-danger"
                type="submit"
                onClick={handleReset}
              >
                Limpar Dados
              </Button>
              <Button
                variant="outline-success"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {data.new ? "Cadastrar Grupo" : "Alterar Grupo"}
              </Button>
            </div>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ModalGroupPermissions;
